import { useSupplierRecord } from "@/app/Suppliers/Hooks/useSupplierRecord";
import { RelocationMultiTable } from "@/app/Relocations/Components/RelocationMultiTable";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { RelocationType } from "@/gql/graphql";
import {
  parseRelocationTableSearch,
  relocationTableSearchFromState,
  relocationTableStateFromSearch,
} from "@/app/Relocations/Utils/relocationTableSearchParams";
import { useSearchBackedState } from "@/lib/Hooks/useSearchBackedState";

export function SupplierRelocationScreen() {
  const record = useSupplierRecord();
  const search = useSearch({
    from: "/$tenant/$orgId/supplier/{-$supplierId}/suppliers/_supplierRecordLayout/$id/relocations",
  });
  const navigate = useNavigate({
    from: "/$tenant/$orgId/supplier/{-$supplierId}/suppliers/$id/relocations",
  });
  const [state, setState] = useSearchBackedState({
    search,
    parseSearch: parseRelocationTableSearch,
    fromSearch: relocationTableStateFromSearch,
    writeSearch: (newState, { replace }) => {
      navigate({
        to: "/$tenant/$orgId/supplier/{-$supplierId}/suppliers/$id/relocations",
        params: (prev) => prev,
        search: relocationTableSearchFromState(newState),
        replace,
      });
    },
  });

  return (
    <div className="py-6">
      <RelocationMultiTable
        tableId={"supplier-relocations"}
        supplierId={record.id}
        type={[RelocationType.Relocation]}
        state={state}
        onStateChange={setState}
      />
    </div>
  );
}
